// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React, { useMemo } from 'react';
import styled from 'styled-components';
import useIsQC from 'hooks/useIsQC';
import { useTranslation } from 'react-i18next';
import { FunctionMenu } from '@tls/treact-ui';

interface Props {
  onOptionClick: (id: string) => void;
  noBorder?: boolean;
}

type OptionType = {
  label: string;
  id: string;
};

const DataElementOptions: React.FC<Props> = ({ onOptionClick, noBorder }) => {
  const isQC = useIsQC();

  const { t } = useTranslation();

  const options: OptionType[] = useMemo(() => {
    const _options = [
      {
        label: t('project.data.elementOptions.editLabel'),
        id: 'editLabel',
      },
      {
        label: t('project.data.elementOptions.editImageTags'),
        id: 'editImageTags',
      },
    ];
    if (isQC) {
      _options.splice(1, 0, {
        label: t('project.data.elementOptions.editAlgorithms'),
        id: 'editAlgorithms',
      });
    }
    return _options;
  }, [isQC, t]);

  return (
    <StyledFunctionMenu
      keySelector={(o: OptionType) => o.id}
      onClick={(o: OptionType) => onOptionClick(o.id)}
      className='moveRight'
      labelSelector={(o: OptionType) => o.label}
      options={options}
      noBorder={noBorder}
      noShadow={noBorder}
    />
  );
};

const StyledFunctionMenu = styled(FunctionMenu)`
  background-color: transparent;
` as typeof FunctionMenu;

export default DataElementOptions;
